import React from 'react';
import { Dialog } from '@economic/taco';
import { useLocation, useNavigate } from 'react-router-dom';
import Accounts from '~/app/views/Accounts';

export default function ChartOfAccountsDialog() {
    const location = useLocation();
    const navigate = useNavigate();

    const open = location.hash === '#chart-of-accounts-search-dialog';
    const selectedAccountNumber = Number.parseInt(location.state?.selectedAccountNumber || '');
    const fieldId = Number.parseInt(location.state?.fieldId || '');

    // In case of navigating directly to the hashed route, the dialog is unusable, so redirect to the base route
    React.useEffect(() => {
        if (!fieldId) {
            navigate(location.pathname);
        }
    }, []);
    if (!fieldId) {
        return null;
    }

    const hide = () => {
        navigate(location.pathname);
    };

    const handleSubmit = account => {
        hide();

        const EconApplet = window.top?.Econ?.frames?.applet;
        const EconPopups = window.top?.Econ?.popups;
        const EconCurrentDialog = window.top?.Econ?._currentPopup?.$dialog;
        const EconForms = window.top?.Econ?.forms;

        if (EconCurrentDialog && EconForms && account.number) {
            EconCurrentDialog.find('[name=Cell' + fieldId + ']').val(account.number);
            EconForms.doSE(fieldId);
        }
        // Set the selected account number in the leagcy form and update the form state
        else if (EconApplet.document.forms[0]['Cell' + fieldId] && account.number) {
            EconApplet.document.forms[0]['Cell' + fieldId].value = account.number;
            EconApplet.doSE(fieldId);
        }
        // Focus on the next element in the legacy form
        else if (EconApplet.document.forms[0]) {
            EconPopups.focusOnNextElement?.(EconApplet.document.forms[0]['Cell' + fieldId]);
        }
    };

    return (
        <Dialog size="md" onClose={hide} open={open} draggable>
            <Dialog.Content aria-label="chart-of-accounts">
                <Accounts onSelected={handleSubmit} selectedAccountNumber={selectedAccountNumber} allowHeadingClick />
            </Dialog.Content>
        </Dialog>
    );
}
